import { Tab, TabList, Tabs } from "@react-spectrum/s2";
import React from 'react';
import type { Key } from 'react';

export interface StatusTabOption {
  id: string;
  label: string;
  count?: number;
}

export interface StatusTabsProps {
  'aria-label': string;
  value: string;
  options: StatusTabOption[];
  onChange: (value: string) => void;
}

export const StatusTabs: React.FC<StatusTabsProps> = ({
  'aria-label': ariaLabel,
  value,
  options,
  onChange,
}) => (
  <Tabs
    aria-label={ariaLabel}
    selectedKey={value}
    onSelectionChange={(key: Key) => onChange(String(key))}
  ><TabList UNSAFE_className="fb-tabs">
      {options.map((option) => (
        <Tab
          id={option.id}
          key={option.id}>
          {option.label}{option.count === undefined ? '' : ` (${option.count})`}
        </Tab>
      ))}
    </TabList></Tabs>
);
